import { Layout } from "@/components/index";
import { extendTheme } from "@chakra-ui/react";
import { ChakraProvider } from "@chakra-ui/provider";
import { useRouter } from "next/router";
import { AuthProvider } from "@/utils/auth";
import "../styles/main.css";
import Head from "next/head";
import { useEffect } from "react";
// export function reportWebVitals(metric) {
//   console.log(metric);
// }
function App({ Component, pageProps }) {
  const { locale } = useRouter();
  const direction = locale === "ar" ? "rtl" : "ltr";
  useEffect(() => {
    let dir = locale == "ar" ? "rtl" : "ltr";
    let lang = locale == "ar" ? "ar" : "en";
    document.querySelector("html").setAttribute("dir", dir);
    document.querySelector("html").setAttribute("lang", lang);
  }, [locale]);

  const theme = extendTheme({
    initialColorMode: "system",
    useSystemColorMode: true,
    styles: {
      global: (props) => ({
        body: {
          bg: props.colorMode === "light" ? "#fcfcfc" : "#1e1e1e",
          color: props.colorMode === "light" ? "#1e1e1e" : "#fcfcfc",
        },
      }),
    },
    direction: direction,
  });
  const getLayout = Component.getLayout || ((page) => page);
  return (
    <AuthProvider>
      <ChakraProvider theme={theme}>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, maximum-scale=5.0"
          />
        </Head>
        <Layout>
          <Component {...pageProps} />
        </Layout>
      </ChakraProvider>
    </AuthProvider>
  );
}

export default App;
